import { render } from "./ContactPhoto.vue?vue&type=template&id=fa8dc98c&scoped=true"
import script from "./ContactPhoto.vue?vue&type=script&lang=js"
export * from "./ContactPhoto.vue?vue&type=script&lang=js"

import "./ContactPhoto.vue?vue&type=style&index=0&id=fa8dc98c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8dc98c"]])

export default __exports__